import React from "react";
import Icon, { type IconComponent } from "@/icons/base";

const SendIcon: IconComponent = ({ ...props }) => (
  <Icon {...props}>
    <path
      d="m7.3294401.4145898c.27628588-.5527864 1.06483392-.5527864 1.3411198 0l7.2471846 14.5c.3198556.6399597-.3524036 1.3218854-.9964951 1.0108239l-6.92224901-3.3424137-6.92024984 3.3424137c-.61481461.2969224-1.25529439-.3109226-1.03405809-.9233937l.03756302-.0874302zm.6705599 2.0114102-5.59382692 11.192 4.84382692-2.339.00029125-2.529c0-.41421356.33565604-.75.74970875-.75s.74970875.33578644.74970875.75l-.00070875 2.529 4.8438273 2.339z"
      fill="currentColor"
    />
  </Icon>
);

export default SendIcon;
